import KunLoading64 from './src/index'

KunLoading64.install = function (Vue) {
	Vue.component(KunLoading64.name, KunLoading64);
}

export default KunLoading64;
